import Card from "~/components/card";
import { useRouter } from "next/router";
import GoogleAd from "~/common/components/GoogleAd";
import AdCard from "~/common/components/AdCard";
import { ADS } from "~/common/constants/googleAds";
import useCollectEvents from "~/common/hooks/useCollectEvents";

const getGrid = (rows) => {
  const available = {
    3: "md:grid-cols-2 lg:grid-cols-3",
    4: "md:grid-cols-2 lg:grid-cols-4",
  };
  return available[rows];
};

const getColSpans = (rows) => {
  const available = {
    3: "md:col-span-2 lg:col-span-3",
    4: "md:col-span-2 lg:col-span-4",
  };
  return available[rows];
};

function prevQueries(expectedQuery, allQueries) {
  return allQueries.reduce((acc, el) => {
    const [key, value] = el.split("=");
    if (expectedQuery === "year") {
      if (key === "lte-year" || key === "gte-year") {
        return acc;
      }
    }
    if (key === "page") {
      // return acc;
      return acc.concat(`&page=1`);
    }
    if (key !== expectedQuery) {
      return acc.concat(`&${key}=${value}`);
    }
    return acc;
  }, "");
}

export default function CarList({
  cars,
  elementsPerRow = 3,
  withAd = false,
  isRecommended = false,
}) {
  const router = useRouter();
  const { collectEvent } = useCollectEvents();

  const handleAdClick = ({ isRecommended }) => {
    const eventName = isRecommended
      ? "car_recommended_list_ad_card_click"
      : "car_list_ad_card_click";

    const url = isRecommended
      ? "https://wa.me/5216621940563?text=Quiero%20%20anunciar%20mi%20auto%20en%20recomendados."
      : "https://wa.me/5216621940563?text=Quiero%20%20anunciar%20mi%20auto.";
    collectEvent({ event: eventName, value: undefined });
    window.open(url);
  };

  return (
    <div className={`grid ${getGrid(elementsPerRow)} gap-8`}>
      {cars.map((car, indx) => {
        const [basePath, queries] = router.asPath.split("?");
        let q = undefined;
        // TODO: Remove page from query param.
        if (queries) {
          q = queries.split("&");
        }
        const metas = [
          /*
          {
            value: car.type,
            link: q
              ? `${basePath}?type=${car.type}${prevQueries("type", q)}`
              : `${basePath}?type=${car.type}`,
            borderless: false,
            key: "type",
          },
          */
          {
            value: car.brand,
            link: q
              ? `${basePath}?brand=${car.brand}${prevQueries("brand", q)}`
              : `${basePath}?brand=${car.brand}`,
            borderless: false,
            key: "brand",
          },
          {
            value: car.year,
            link: q
              ? `${basePath}?year=${car.year}${prevQueries("year", q)}`
              : `${basePath}?year=${car.year}`,
            borderless: false,
            key: "year",
          },
          {
            value: car.transmission,
            link: q
              ? `${basePath}?transmission=${car.transmission}${prevQueries(
                  "transmission",
                  q
                )}`
              : `${basePath}?transmission=${car.transmission}`,
            borderless: false,
            key: "transmission",
          },
          {
            value: car.city,
            link: q
              ? `${basePath}?city=${car.city}${prevQueries("city", q)}`
              : `${basePath}?city=${car.city}`,
            borderless: false,
            key: "city",
          },
          {
            value: car.state,
            link: q
              ? `${basePath}?state=${car.state}${prevQueries("state", q)}`
              : `${basePath}?state=${car.state}`,
            borderless: false,
            key: "state",
          },
        ];
        if (withAd) {
          if ((indx + 1) % (elementsPerRow * 2) === 0) {
            return (
              <>
                <div className={`${getColSpans(elementsPerRow)}`}>
                    <GoogleAd adSlot={ADS.PRINCIPAL_BANNER} />
                </div>
                <Card
                  id={car.id}
                  slug={car.slug}
                  key={car.id}
                  car={car.title}
                  cover={car.cover}
                  price={car.price}
                  metas={metas}
                  isRecomended={car.isPremium}
                />
              </>
            );
          }
        }

        if (indx + 1 === 4) {
          return isRecommended ? (
            <>
              <AdCard
                price="$ precio de tu auto"
                image="/SS.jpg"
                title="Marca y modelo de tu auto"
                pills={[
                  "Metricas",
                  "Modificaciones",
                  "Atencion a cliente",
                  "60 dias de publicacion en recomendado",
                  "Prioridad en filtros y sugerencias",
                ]}
                onClick={() => handleAdClick({ isRecommended: true })}
              />
              <Card
                id={car.id}
                slug={car.slug}
                key={car.id}
                car={car.title}
                cover={car.cover}
                price={car.price}
                metas={metas}
                isRecomended={car.isPremium}
              />
            </>
          ) : (
            <>
              <AdCard
                price="$ precio de tu auto"
                // image="https://placehold.co/640x480"
                image="/SS.jpg"
                title="Marca y modelo de tu auto"
                pills={[
                  "Metricas",
                  "Modificaciones",
                  "60 dias de publicacion",
                  "Atencion a cliente",
                ]}
                onClick={() => handleAdClick({ isRecommended: false })}
              />
              <Card
                id={car.id}
                slug={car.slug}
                key={car.id}
                car={car.title}
                cover={car.cover}
                price={car.price}
                metas={metas}
                isRecomended={car.isPremium}
              />
            </>
          );
        }

        return (
          <Card
            id={car.id}
            slug={car.slug}
            key={car.id}
            car={car.title}
            cover={car.cover}
            price={car.price}
            metas={metas}
            isRecomended={car.isPremium}
          />
        );
      })}
    </div>
  );
}
